import { render, staticRenderFns } from "./ModalPrint.vue?vue&type=template&id=3063189a&scoped=true&"
import script from "./ModalPrint.vue?vue&type=script&lang=js&"
export * from "./ModalPrint.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrint.vue?vue&type=style&index=0&id=3063189a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063189a",
  null
  
)

export default component.exports